module.exports = __webpack_public_path__ + "img/30.d8623c36.jpg";